import { ca } from '@cian/analytics';
import { IJsonQuery } from '../../../types/jsonQuery';

export const trackEntryPointClick = ({ jsonQuery, regionId }: { jsonQuery: IJsonQuery; regionId: number }) =>
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat_kpn_entry',
    action: 'Click_sopr',
    label: 'Click',
    sc: jsonQuery,
    useLastProducts: true,
    page: {
      pageType: 'ListingJK',
      siteType: 'desktop',
      extra: {
        region: regionId,
      },
    },
  });

export const trackEntryAutorisationPopupOpen = ({
  jsonQuery,
  label,
  regionId,
}: {
  jsonQuery: IJsonQuery;
  label: string;
  regionId: number;
}) =>
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat_kpn_entry_popup',
    action: 'Show_sopr',
    label,
    sc: jsonQuery,
    useLastProducts: true,
    page: {
      pageType: 'ListingJK',
      siteType: 'desktop',
      extra: {
        region: regionId,
      },
    },
  });

export const trackEntryAutorisationPopupClick = ({
  jsonQuery,
  label,
  regionId,
}: {
  jsonQuery: IJsonQuery;
  label: string;
  regionId: number;
}) =>
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat_kpn_entry_popup',
    action: 'Click_sopr',
    label,
    sc: jsonQuery,
    useLastProducts: true,
    page: {
      pageType: 'ListingJK',
      siteType: 'desktop',
      extra: {
        region: regionId,
      },
    },
  });

export const trackOpenChatPopup = ({
  label,
  chatId,
  botId,
  userId,
  regionId,
}: {
  label: string;
  chatId: string;
  botId: number;
  userId?: number;
  regionId: number;
}) =>
  ca('eventSite', {
    name: 'oldevent',
    category: 'Message_popup',
    action: 'open',
    label,
    useLastProducts: true,
    page: {
      pageType: 'ListingJK',
      siteType: 'desktop',
      extra: {
        chat_id: chatId,
        bot_id: botId,
        owner_id: userId,
        region: regionId,
      },
    },
  });

export const onAnimationShown = ({ label }: { label: string }) =>
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat_kpn_animation',
    action: 'Show_sopr',
    label,
    useLastProducts: true,
  });

export const onAnimationTooltipShown = ({ label }: { label: string }) =>
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat_kpn_tooltip',
    action: 'Show_sopr',
    label,
    useLastProducts: true,
  });
